import { all, call, put, takeLatest, select } from "redux-saga/effects";

import { fetchAdminCoinValueEditFailure, fetchAdminCoinValueEditSuccess } from "./actions";
import { FETCH_ADMIN_COIN_VALUE_EDIT_REQUEST } from "./actionTypes";

import { FetchAdminCoinValueEditRequest } from "./types";

import { getAdminCoinValueEditInsert, getAdminCoinValueEditUpdate, getAdminCoinValueEditElim } from "./api";

import { getResultUserLoginSelector } from "../userLogin/selectors";

import { fetchCoinValueSaga } from "../coinValue/sagas";

export function* fetchAdminCoinValueEditSaga(action: FetchAdminCoinValueEditRequest): any {
  try {
    let response: any;

    
  
    if (action.query.idDelete && action.query.idDelete!='') {
      response = yield call(getAdminCoinValueEditElim, action.query.idDelete);
    } else {
      if (action.query.id && action.query.id!='') {
        response = yield call(getAdminCoinValueEditUpdate, action.query.id, action.query);
      } else {
        response = yield call(getAdminCoinValueEditInsert, action.query);  
      }
    }

    if (response && response.id && response.id != "") {
      //yield call(fetchEmojiSaga, { query: {serieId: action.query.serie_id} });
      yield call(fetchCoinValueSaga);
      yield put(
        fetchAdminCoinValueEditSuccess({
          result: response,
        })
      );
    }


  } catch (error) {
    let errorMessage = "Failed to do something exceptional";
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    yield put(fetchAdminCoinValueEditFailure({ error: errorMessage }));
  }
}

function* AdminCoinValueEditSaga() {
  yield all([takeLatest(FETCH_ADMIN_COIN_VALUE_EDIT_REQUEST, fetchAdminCoinValueEditSaga)]);
}

export default AdminCoinValueEditSaga;
